import React from 'react';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { trendsReports as TrendsReportsView } from 'ui/views/widgets/trendsReports';
import { TrendsReportsService } from 'services/trendsReports';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { TrendsReports } from 'ui/containers/TrendsReports';
 *
 * // render
 * <TrendsReports propName='propValue'/>
 */
export class TrendsReports extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.trendsReportsService = new TrendsReportsService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'TrendsReports.fetchComponentData()' );

        // cancel ongoing request
        this.trendsReportsService.cancel();

        // get status and service data
        const { status, data } = await this.trendsReportsService.fetchComponentData( {
            url: this.props.widget.url
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unMounts, cleanup resources.
     */
    componentWillUnmount() {
        this.trendsReportsService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <TrendsReportsView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
TrendsReports.displayName = 'TrendsReports';

// set default props
TrendsReports.defaultProps = {};

// prop types
TrendsReports.propTypes = {};
